declare namespace $ {

	type $mol_check_box__title_shm_hitalama_project_codex_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__hint_shm_hitalama_project_codex_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_project_codex['completion_sound_hint'] >
		,
		ReturnType< $mol_check_box['hint'] >
	>
	type $mol_check_box__checked_shm_hitalama_project_codex_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_project_codex['completion_sound_enabled'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	export class $shm_hitalama_project_codex extends $shm_codex_app {
		completion_sound_hint( ): string
		completion_sound_enabled( next?: boolean ): boolean
		sessions_page_visible( ): boolean
		width( next?: number ): number
		width_px( ): string
		project_id( ): string
		Completion_sound( ): $mol_check_box
		style( ): ({ 
			'width': ReturnType< $shm_hitalama_project_codex['width_px'] >,
			'flexBasis': ReturnType< $shm_hitalama_project_codex['width_px'] >,
			'flexGrow': number,
			'flexShrink': number,
			'minWidth': string,
		})  & ReturnType< $shm_codex_app['style'] >
	}
	
}

//# sourceMappingURL=codex.view.tree.d.ts.map